/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lessons_Title_AccentInputs */

const en_lessons_title_accent = /** @type {(inputs: Lessons_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`designed around you.`)
};

const es_lessons_title_accent = /** @type {(inputs: Lessons_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`diseñadas para ti.`)
};

const de_lessons_title_accent = /** @type {(inputs: Lessons_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ganz auf Sie zugeschnitten.`)
};

const zh_lessons_title_accent = /** @type {(inputs: Lessons_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为你量身定制。`)
};

const ar_lessons_title_accent = /** @type {(inputs: Lessons_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مصمّمة خصيصاً لك.`)
};

const fr_lessons_title_accent = /** @type {(inputs: Lessons_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`conçus pour vous.`)
};

const vi_lessons_title_accent = /** @type {(inputs: Lessons_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`thiết kế riêng cho bạn.`)
};

const sw_lessons_title_accent = /** @type {(inputs: Lessons_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`yaliyoundwa kwa ajili yako.`)
};

const th_lessons_title_accent = /** @type {(inputs: Lessons_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ที่ออกแบบมาเพื่อคุณ`)
};

const bs_lessons_title_accent = /** @type {(inputs: Lessons_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`prilagođene vama.`)
};

const ja_lessons_title_accent = /** @type {(inputs: Lessons_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`あなたのために設計。`)
};

const ko_lessons_title_accent = /** @type {(inputs: Lessons_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`개인 레슨.`)
};

const pt_lessons_title_accent = /** @type {(inputs: Lessons_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pensadas para você.`)
};

const it_lessons_title_accent = /** @type {(inputs: Lessons_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pensate su misura per te.`)
};

const sv_lessons_title_accent = /** @type {(inputs: Lessons_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`anpassade efter dig.`)
};

const nl_lessons_title_accent = /** @type {(inputs: Lessons_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`afgestemd op jou.`)
};

const da_lessons_title_accent = /** @type {(inputs: Lessons_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`skræddersyet til dig.`)
};

const nb_lessons_title_accent = /** @type {(inputs: Lessons_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`skreddersydd for deg.`)
};

const fi_lessons_title_accent = /** @type {(inputs: Lessons_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`juuri sinulle suunniteltuna.`)
};

const pl_lessons_title_accent = /** @type {(inputs: Lessons_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dopasowane do ciebie.`)
};

const ru_lessons_title_accent = /** @type {(inputs: Lessons_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`созданные специально для вас.`)
};

const tr_lessons_title_accent = /** @type {(inputs: Lessons_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`size göre tasarlanmış.`)
};

const hi_lessons_title_accent = /** @type {(inputs: Lessons_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पूरी तरह आपके लिए।`)
};

const id_lessons_title_accent = /** @type {(inputs: Lessons_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dirancang khusus untuk Anda.`)
};

const ms_lessons_title_accent = /** @type {(inputs: Lessons_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`direka mengikut keperluan anda.`)
};

const cs_lessons_title_accent = /** @type {(inputs: Lessons_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`navržené přímo pro vás.`)
};

const el_lessons_title_accent = /** @type {(inputs: Lessons_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`προσαρμοσμένα σε εσάς.`)
};

const he_lessons_title_accent = /** @type {(inputs: Lessons_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מותאמים אישית עבורכם.`)
};

const af_lessons_title_accent = /** @type {(inputs: Lessons_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`op maat vir jou gemaak.`)
};

const hu_lessons_title_accent = /** @type {(inputs: Lessons_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kifejezetten neked szabva.`)
};

/**
* | output |
* | --- |
* | "designed around you." |
*
* @param {Lessons_Title_AccentInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const lessons_title_accent = /** @type {((inputs?: Lessons_Title_AccentInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lessons_Title_AccentInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_lessons_title_accent(inputs)
	if (locale === "de") return de_lessons_title_accent(inputs)
	if (locale === "zh") return zh_lessons_title_accent(inputs)
	if (locale === "ar") return ar_lessons_title_accent(inputs)
	if (locale === "fr") return fr_lessons_title_accent(inputs)
	if (locale === "vi") return vi_lessons_title_accent(inputs)
	if (locale === "sw") return sw_lessons_title_accent(inputs)
	if (locale === "th") return th_lessons_title_accent(inputs)
	if (locale === "bs") return bs_lessons_title_accent(inputs)
	if (locale === "ja") return ja_lessons_title_accent(inputs)
	if (locale === "ko") return ko_lessons_title_accent(inputs)
	if (locale === "pt") return pt_lessons_title_accent(inputs)
	if (locale === "it") return it_lessons_title_accent(inputs)
	if (locale === "sv") return sv_lessons_title_accent(inputs)
	if (locale === "nl") return nl_lessons_title_accent(inputs)
	if (locale === "da") return da_lessons_title_accent(inputs)
	if (locale === "nb") return nb_lessons_title_accent(inputs)
	if (locale === "fi") return fi_lessons_title_accent(inputs)
	if (locale === "pl") return pl_lessons_title_accent(inputs)
	if (locale === "ru") return ru_lessons_title_accent(inputs)
	if (locale === "tr") return tr_lessons_title_accent(inputs)
	if (locale === "hi") return hi_lessons_title_accent(inputs)
	if (locale === "id") return id_lessons_title_accent(inputs)
	if (locale === "ms") return ms_lessons_title_accent(inputs)
	if (locale === "cs") return cs_lessons_title_accent(inputs)
	if (locale === "el") return el_lessons_title_accent(inputs)
	if (locale === "he") return he_lessons_title_accent(inputs)
	if (locale === "af") return af_lessons_title_accent(inputs)
	if (locale === "hu") return hu_lessons_title_accent(inputs)
	return en_lessons_title_accent(inputs)
});